// extracted by mini-css-extract-plugin
module.exports = {"mergeModal":"mergeModal__+OzUB","text":"text__YBUo1","select":"select__OfHur","list":"list__bv9or","item":"item__+tehO","check":"check__TJo7+"};